import React from "react"
import types from "prop-types"
import { MenuButton } from "@szhsin/react-menu"
import * as API from "services/api"
import ItemRow from "shared/ItemRow"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import { errorToast } from "shared/toast"
import { FormIcon } from "shared/icons"
import { unpaddedNumberDate } from "utils/dateHelpers"
import { deletedSubmissionShape } from "utils/propTypeShapes"

const DeletedSubmission = ({ submission, onSubmissionRecovered }) => {
  const recoverSubmission = async () => {
    const response = await API.recoverFormSubmission({ slug: submission.slug })

    if (response.ok) {
      onSubmissionRecovered(submission)
    } else {
      errorToast("Something went wrong. Unable to recover the submission.")
    }
  }

  return (
    <ItemRow
      itemRowHeaderContent={(
        <>
          <span className="whitespace-nowrap">{ submission.slug }</span>
          <span>{ unpaddedNumberDate(submission.createdAt) }</span>
          <div className="flex items-center">
            <FormIcon form={submission.form} className="mr-2 h-6 w-6 shrink-0" />
            <span className="truncate">{ submission.form.title }</span>
          </div>
          <div>{ submission.statusName }</div>
        </>
      )}
      itemRowHeaderControls={(
        <ExpandMenu
          expandMenuComponent={(
            <MenuButton className="circular-icon-button p-2.5" aria-label="show menu">
              <svg className="!w-4 !h-4" aria-hidden><use xlinkHref="#ellipsis" /></svg>
            </MenuButton>
          )}
        >
          <ExpandMenuItem onClick={recoverSubmission}>
            <span>Recover</span>
          </ExpandMenuItem>
        </ExpandMenu>
      )}
    />
  )
}

DeletedSubmission.propTypes = {
  submission: deletedSubmissionShape.isRequired,
  onSubmissionRecovered: types.func.isRequired,
}

export default DeletedSubmission
